import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/clerk-react";

const _UNSET = {};
const OrgIdContext = createContext(_UNSET);

export function OrgIdProvider({ children }) {
  const { orgId } = useAuth();
  const [currentOrgId, setCurrentOrgId] = useState(orgId);

  useEffect(() => {
    setCurrentOrgId(orgId);
  }, [orgId]);

  return (
    <OrgIdContext.Provider value={currentOrgId}>
      {children}
    </OrgIdContext.Provider>
  );
}

export function useOrgId() {
  const context = useContext(OrgIdContext);
  if (context === _UNSET) {
    throw new Error("useOrgId must be used within OrgIdProvider");
  }
  return context;
}
